// extracted by mini-css-extract-plugin
export default {"wrapper":"work_wrapper__omhu8","container":"work_container__GY8ZA"};